module.exports = __webpack_public_path__ + "img/techradar.5bda8c1.png";